import type { TranslationTag } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import HideCardInfoImg from '../../../../../../../assets/card-hiding.svg';
import InfoPrompt from '../../../../../../InfoPrompt/InfoPrompt';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import {
  contentText,
  image,
  mainTitle,
  optionText,
  optionWrapper,
  optionsGroup
} from '../DocumentRequirements.scss';

import {
  TXTWCL_Masking_your_card,
  TXTWCL_Show_the_first_6_and_last_4_di_ELL
} from './DocumentsGroup.messages.json';

type SVGProps = React.SVGAttributes<SVGElement>;

export interface Props {
  title: TranslationTag;
  options: TranslationTag[];
  icon?: React.ReactElement<SVGProps, React.FunctionComponent<SVGProps>>;
  i18nSystemName: string;
  cardHidingIcon?: boolean;
  iconIndex?: number;
}

const DocumentsGroup: React.FC<Props> = ({
  title,
  options,
  icon,
  i18nSystemName,
  cardHidingIcon,
  iconIndex
}) => (
  <div>
    <p className={mainTitle}>
      <Translation {...title} />
    </p>
    <div className={optionsGroup}>
      {options.map((option, index: number) => (
        <div key={index} className={optionWrapper}>
          {icon}
          <p className={optionText}>
            <Translation {...option} values={{ 0: i18nSystemName }} />
            {index === iconIndex && cardHidingIcon && (
              <InfoPrompt title={{ translation: TXTWCL_Masking_your_card }} variant="verification">
                <div className={contentText}>
                  <Translation {...TXTWCL_Show_the_first_6_and_last_4_di_ELL} />
                </div>
                <HideCardInfoImg className={image} />
              </InfoPrompt>
            )}
          </p>
        </div>
      ))}
    </div>
  </div>
);

export default DocumentsGroup;
